import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import ErrorModal from '../../modal/util/ErrorModal';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import { defaultRejectHandler, getStatusStyle, stringifyErrorMessage } from '../../utils/utility';
import { searchACCentralByText } from '../../redux/ac_central/ac_central_actions';

import {
  listACCentralGroupsInProject,
  bindACCentralToProject,
  unbindACCentralGroupFromProject,
  clearErrorProjectACCentral,
} from '../../redux/projects/project_ac_central_actions';
import { getProject } from '../../redux/projects/projects_actions';


export class ACCentralGroupsDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.state = {
      searchText: '',
      isShowErrorModal: false,
    };

    // Error message translations
    this.errorMessages = {
      'This project already has an AC central bound.': {
        th: 'โครงการนี้มีระบบปรับอากาศแบบรวมศูนย์อยู่แล้ว',
        en: 'This project already has an AC central bound.',
      },
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...textColumn,
        entity: {
          list: (text, page) => searchACCentralByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: 'chiller_cooling_capacity',
        ...coeColumn,
        width: 160,
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'chiller_status',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        width: 80,
        ...textColumn,
      },
    ];
  }

  componentDidMount() {
    this.props.listACCentralGroups();
  }

  componentDidUpdate(prevProps) {
    // Show error modal when there's a new error
    if (this.props.bindErrorMessage && this.props.bindErrorMessage !== prevProps.bindErrorMessage) {
      this.setState({ isShowErrorModal: true });
    }
  }

  getTranslatedErrorMessage() {
    const { bindErrorMessage, i18n } = this.props;
    if (!bindErrorMessage) return null;

    const errorDetail = bindErrorMessage.detail || bindErrorMessage;
    const lang = i18n.language.split('-')[0];
    
    // Check if we have a translation for this error
    const translation = this.errorMessages[errorDetail];
    if (translation) {
      return translation[lang] || translation.en;
    }
    
    return errorDetail;
  }

  dismissErrorModal = () => {
    this.setState({ isShowErrorModal: false });
    this.props.clearError();
  }

  getFilteredData() {
    const { groups } = this.props;
    const { searchText } = this.state;
    
    if (!searchText) return groups;
    
    const lowerSearch = searchText.toLowerCase();
    return groups.filter(item => 
      item.name && item.name.toLowerCase().includes(lowerSearch)
    );
  }

  render() {
    const {
      projectId,
      isGroupsLoading,
      bindACCentral,
      unbindACCentralGroup,
      isACCentralAdding,
      isACCentralRemoving,
      groupsErrorMessage,
      buildings,
    } = this.props;

    const relationship = {
      create: ({ entityId }) => bindACCentral(entityId),
      delete: (id, item) => unbindACCentralGroup(item.ids || [id]),
      isCreating: isACCentralAdding,
      isDeleting: isACCentralRemoving,
    };

    const filteredData = this.getFilteredData();

    return (
      <div style={{ backgroundColor: 'white' }}>
        <ErrorModal
          show={this.state.isShowErrorModal}
          errorMessage={this.getTranslatedErrorMessage()}
          onHide={this.dismissErrorModal}
        />
        <SearchBar onSearch={text => this.setState({ searchText: text })} />
        <RelationDataTable
          columns={this.columns}
          data={filteredData.map((item, index) => ({ ...item, id: item.master_id || index }))}
          errorMessage={stringifyErrorMessage(groupsErrorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredData.length}
          isLoading={isGroupsLoading}
          onFetchData={() => {}}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  groups: state.projectACCentral.groups || [],
  isGroupsLoading: state.projectACCentral.isGroupsLoading,
  groupsErrorMessage: state.projectACCentral.groupsErrorMessage,
  bindErrorMessage: state.projectACCentral.errorMessage,
  isACCentralAdding: state.projectACCentral.isCreating,
  isACCentralRemoving: state.projectACCentral.isDeleting,
});

const mapDispatchToProps = (dispatch, props) => ({
  listACCentralGroups: () =>
    defaultRejectHandler(dispatch(listACCentralGroupsInProject(props.projectId))),
  bindACCentral: (acCentralId) =>
    dispatch(bindACCentralToProject(props.projectId, acCentralId))
      .then(() => {
        dispatch(getProject(props.projectId));
        dispatch(listACCentralGroupsInProject(props.projectId));
      }),
  unbindACCentralGroup: (acCentralIds) =>
    defaultRejectHandler(dispatch(unbindACCentralGroupFromProject(props.projectId, acCentralIds))
      .then(() => {
        dispatch(getProject(props.projectId));
        dispatch(listACCentralGroupsInProject(props.projectId));
      })),
  clearError: () => dispatch(clearErrorProjectACCentral()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACCentralGroupsDataTable),
);




// WEBPACK FOOTER //
// ./src/components/project_detail/ACCentralGroupsDataTable.js